import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getHistories({ commit }, document) {
    return axios.get(`/histories/${document.type}/${document.id}`)
  }
}
